var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2784_3415)" } }, [
        _c("path", {
          attrs: {
            d: "M3.5625 1.13037V2.31787H1.78125C0.797852 2.31787 0 3.11572 0 4.09912V5.88037H16.625V4.09912C16.625 3.11572 15.8271 2.31787 14.8438 2.31787H13.0625V1.13037C13.0625 0.473535 12.5318 -0.0571289 11.875 -0.0571289C11.2182 -0.0571289 10.6875 0.473535 10.6875 1.13037V2.31787H5.9375V1.13037C5.9375 0.473535 5.40684 -0.0571289 4.75 -0.0571289C4.09316 -0.0571289 3.5625 0.473535 3.5625 1.13037ZM16.625 7.06787H0V17.1616C0 18.145 0.797852 18.9429 1.78125 18.9429H14.8438C15.8271 18.9429 16.625 18.145 16.625 17.1616V7.06787Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2784_3415" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0 0.942871)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }